import { SplitFactory } from '@splitsoftware/splitio';
import { useEffect, useState } from 'react';

const PROD_KEY = 'npfbpvf0pqksu5aen170sqcjjbhkimr5oesr';
const QA_KEY = 'm8lsfvb0kht69lh2nmqf4uut16thu1vrssau';
const DEV_KEY = 'mr6oqt6ovar6d8va9bv6kg1ro01lluri9686';

function getSplitIOKey(host = 'dev.evbqa.com') {
    if (host.indexOf('eventbrite') > -1) {
        return PROD_KEY;
    }

    if (host.indexOf('dev') > -1) {
        return DEV_KEY;
    }

    if (host.indexOf('evbqa') > -1) {
        return QA_KEY;
    }

    return DEV_KEY;
}

export function useSDKFeatureFlag() {
    const [shouldUseSDK, setShouldUseSDK] = useState(false);
    const [isLoaded, setIsLoaded] = useState(false);

    useEffect(() => {
        if (typeof window === 'undefined') {
            return;
        }
        if (process.env.NODE_ENV === 'test') {
            setIsLoaded(true);
            setShouldUseSDK(false);
            return;
        }
        const factory: SplitIO.ISDK = SplitFactory({
            core: {
                authorizationKey: getSplitIOKey(window.location.host),
                key: window.__SERVER_DATA__.guest_id,
            },
            startup: {
                readyTimeout: 1.5,
            },
        });

        const client: SplitIO.IClient = factory.client();
        client.on(client.Event.SDK_READY, function () {
            const treatment: SplitIO.Treatment = client.getTreatment(
                'event_promotion_analytics_fe_sdk',
                {
                    guest_id: window.__SERVER_DATA__.guest_id,
                },
            );
            if (treatment == 'on') {
                setShouldUseSDK(true);
                setIsLoaded(true);
            } else {
                setShouldUseSDK(false);
                setIsLoaded(true);
            }
        });
    }, []);

    if (!isLoaded) return null;

    return shouldUseSDK;
}
